import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { AnimatedLineGraph } from './pages/AnimatedLineGraph';
import { AnimatedBarGraphPage } from './pages/AnimatedBarGraph';
import { AnimatedPieGraphPage } from './pages/AnimatedPieGraph';
import AnimatedScatterPlotPage from './pages/AnimatedScatterPlot';
import { AnimatedRegionMapPage } from './pages/AnimatedRegionMap';
import { Analytics } from '@vercel/analytics/react';
import './App.css';
import { useState, useEffect } from 'react';

function App() {
  return (
    <BrowserRouter>
      <div>
        <nav style={{
          backgroundColor: '#333',
          padding: '1rem',
          marginBottom: '2rem'
        }}>
          <div style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'center',
            gap: '1rem'
          }}>
            <Link to="/" style={{ color: 'white', textDecoration: 'none' }}>Home</Link>
            <Link to="/line-graph" style={{ color: 'white', textDecoration: 'none' }}>Line Graph</Link>
            <Link to="/bar-graph" style={{ color: 'white', textDecoration: 'none' }}>Bar Graph</Link>
            <Link to="/pie-graph" style={{ color: 'white', textDecoration: 'none' }}>Pie Graph</Link>
            <Link to="/scatter-plot" style={{ color: 'white', textDecoration: 'none' }}>Scatter Plot</Link>
            <Link to="/region-map" style={{ color: 'white', textDecoration: 'none' }}>Region Map</Link>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/line-graph" element={<AnimatedLineGraph />} />
          <Route path="/bar-graph" element={<AnimatedBarGraphPage />} />
          <Route path="/pie-graph" element={<AnimatedPieGraphPage />} />
          <Route path="/scatter-plot" element={<AnimatedScatterPlotPage />} />
          <Route path="/region-map" element={<AnimatedRegionMapPage />} />
          <Route path="/test" element={<TestPage />} />
        </Routes>
        
        <footer
          style={{
            marginTop: '3rem',
            padding: '1.25rem 1rem',
            borderTop: '1px solid rgba(0,0,0,0.12)',
            color: '#666',
            textAlign: 'center',
          }}
        >
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <span style={{ fontWeight: 600, color: '#444' }}>Our other handy web apps:</span>{' '}
            <a href="https://mapcreator.org" target="_blank" rel="noreferrer" style={{ color: '#646cff' }}>
              mapcreator.org
            </a>{' '}
            <span style={{ color: '#aaa' }}>|</span>{' '}
            <a href="https://kitchensync.club" target="_blank" rel="noreferrer" style={{ color: '#646cff' }}>
              kitchensync.club
            </a>{' '}
            <span style={{ color: '#aaa' }}>|</span>{' '}
            <a href="https://cartoonrebus.com" target="_blank" rel="noreferrer" style={{ color: '#646cff' }}>
              cartoonrebus.com
            </a>
          </div>
        </footer>

        <Analytics />
      </div>
    </BrowserRouter>
  );
}

function Home() {
  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{ marginBottom: '2rem' }}>
        <img 
          src="/logo_graffy2.png" 
          alt="Graffy.ca Logo" 
          style={{
            maxWidth: '300px',
            height: 'auto',
            marginBottom: '1rem'
          }}
        />
      </div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '2rem',
        marginTop: '2rem'
      }}>
        <GraphCard
          title="Animated Line Graph"
          description="Create beautiful animated line graphs with customizable settings and smooth animations."
          link="/line-graph"
        />
        <GraphCard
          title="Animated Bar Graph"
          description="Visualize your data with dynamic bar graphs featuring smooth animations and interactive controls."
          link="/bar-graph"
        />
        <GraphCard
          title="Animated Pie Graph"
          description="Create animated pie charts with custom colors and smooth transitions."
          link="/pie-graph"
        />
        <GraphCard
          title="Animated XY Scatter Plot"
          description="Visualize relationships between two variables with animated scatter plots."
          link="/scatter-plot"
        />
        <GraphCard
          title="Animated US & Canada region map"
          description="Paste a spreadsheet of states or provinces and hex colors to animate a choropleth map."
          link="/region-map"
        />
      </div>
    </div>
  );
}

function GraphCard({ title, description, link }: { title: string; description: string; link: string }) {
  return (
    <Link to={link} style={{ textDecoration: 'none', color: 'inherit' }}>
      <div style={{
        padding: '2rem',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        transition: 'transform 0.2s',
        cursor: 'pointer'
      }}>
        <h2 style={{ marginBottom: '1rem', color: '#333' }}>{title}</h2>
        <p style={{ color: '#666' }}>{description}</p>
      </div>
    </Link>
  );
}

function TestPage() {
  const [testResult, setTestResult] = useState<string>('Testing...');
  const [optionsResult, setOptionsResult] = useState<string>('Testing OPTIONS...');

  useEffect(() => {
    // Test basic connectivity
    fetch('https://graffy-production.up.railway.app/test')
      .then(response => response.json())
      .then(data => setTestResult(JSON.stringify(data, null, 2)))
      .catch(error => setTestResult(`Error: ${error.message}`));

    // Test OPTIONS preflight
    fetch('https://graffy-production.up.railway.app/test', {
      method: 'OPTIONS',
      headers: {
        'Origin': 'https://graffy.ca'
      }
    })
      .then(response => {
        setOptionsResult(`Status: ${response.status}, Headers: ${JSON.stringify(Object.fromEntries(response.headers.entries()), null, 2)}`);
      })
      .catch(error => setOptionsResult(`Error: ${error.message}`));
  }, []);

  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <h1>Backend Test Page</h1>
      <div style={{ textAlign: 'left', marginTop: '2rem' }}>
        <h2>GET Test:</h2>
        <pre style={{ backgroundColor: '#f5f5f5', padding: '1rem', borderRadius: '4px' }}>
          {testResult}
        </pre>
        
        <h2>OPTIONS Test:</h2>
        <pre style={{ backgroundColor: '#f5f5f5', padding: '1rem', borderRadius: '4px' }}>
          {optionsResult}
        </pre>
      </div>
    </div>
  );
}

export default App;
